import base from "./base/index"; // 接口域名列表
import axios from "../utils/http"; // 导入http中创建的axios实例
import utils from "../utils";
/**
 * 触发器
 */
const trigger = {

  /**
   * 添加
   */
  addTrigger (name, variables, subscribingBusEvents, handlingFunction, remark, companyId) {
    return axios.post(base.trigger.addTrigger, utils.postParamsArrayToJsonString({ name, variables, subscribingBusEvents, handlingFunction, remark, companyId }))
  },
  /**
   * 修改
   */
  modifyTrigger (id, name, variables, subscribingBusEvents, handlingFunction, remark) {
    return axios.post(base.trigger.modifyTrigger, utils.postParamsArrayToJsonString({ id, name, variables, subscribingBusEvents, handlingFunction, remark }))
  },
  /**
   * 启用
   */
  enableTrigger (id) {
    return axios.post(base.trigger.enableTrigger, utils.postParamsArrayToJsonString({ id }))
  },
  /**
   * 停用
   */
  disableTrigger (id) {
    return axios.post(base.trigger.disableTrigger, utils.postParamsArrayToJsonString({ id }))
  },
  /**
   * 删除
   */
  deleteTrigger (id) {
    return axios.post(base.trigger.deleteTrigger, utils.postParamsArrayToJsonString({ id }))
  },
  /**
   * 查询
   */
  getTriggers (companyId) {
    return axios.post(base.trigger.getTriggers, utils.postParamsArrayToJsonString({ companyId }))
  },
  /**
   * 获取触发器变量值
   */
  getTriggerVariablesValue (id, variables) {
    return axios.post(base.trigger.getTriggerVariablesValue, utils.postParamsArrayToJsonString({ id, variables }))
  },
}

export default trigger